import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { EarnPointsStore, EarnPointsState } from './earn-points.store';

@Injectable({ providedIn: 'root' })
export class EarnPointsQuery extends QueryEntity<EarnPointsState> {
  constructor(protected store: EarnPointsStore) {
    super(store);
  }
}
